import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Add.js
// module id = 1852
// module chunks = 2